import getConfig from 'next/config';

export const { publicRuntimeConfig: APP_CONFIG } = getConfig() || {
  publicRuntimeConfig: { basePath: '/' },
};
